import { useEffect, useState } from "react";
import CustomSupplierRequest from "../../components/customSupplierRequest/CustomSupplierRequest";
import { useGetSupplierRequest } from "../../api/supplier";
import { useSupplierDrawingReminder } from "../../api/notification";

const MappingRequest = ({ currentAvailableMappingRequest = () => {} }: any) => {
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [pageLimit, setPageLimit] = useState<any>(10);
  const [searchKey, setSearchKey] = useState<string>("");

  const {
    isLoading: isSupplierRequestLoading,
    data: supplierRequestData,
    refetch
  } = useGetSupplierRequest(pageNumber, pageLimit, searchKey);

  const result = supplierRequestData?.result || [];

  const { mutate } = useSupplierDrawingReminder();

  useEffect(() => {
    if (supplierRequestData) {
      currentAvailableMappingRequest(result);
    }
  }, [supplierRequestData]);

  const onReminder = (item: any) => {
    mutate({
      ingredientId: item.ingredientId,
      supplierUserId: item.supplierUserId
    });
  };

  const handlePagination = (currentPage: any) => {
    setPageNumber(currentPage);
  };

  const handlePageSize = (pageSize: any) => {
    setPageLimit(pageSize);
  };

  return (
    <div>
      <CustomSupplierRequest
        dataTotal={supplierRequestData?.total || 0}
        pageNumber={pageNumber}
        pageLimit={pageLimit}
        data={result}
        onReminder={onReminder}
        handlePagination={handlePagination}
        handlePageSize={handlePageSize}
        setSearchKey={setSearchKey}
        searchKey={searchKey}
        refetch={refetch}
        isRecipeListLoading={isSupplierRequestLoading}
      />
    </div>
  );
};

export default MappingRequest;
